import HeadHelmet from '@/components/shared/HeadHelmet'
import Shell from '@/components/layout/templates/Default'
import {useState, useEffect} from 'react'
import {useMutation} from '@apollo/react-hooks'
import Listing from '../listing/ListingAddress'
import {getAddressInput} from '@/lib/address'
import Info from './Steps/Info'
import StepByStep from '@/components/shared/StepByStep'
import ESTIMATE_PRICE from '@/graphql/mutations/estimatePrice'
import Evaluation from './Steps/Evaluation'
import {useHistory} from 'react-router-dom'
import {
  STEPINFOCONSTS,
  sentences,
  isBackButtonDisabled,
  isFwdButtonDisabled
} from './lib'
import Intro from './Steps/Intro'

const getStateValue = (state, key, d) => (state && state[key]) || d

const Evaluator = ({location: {state}}) => {
  const {INITIAL_STEP} = STEPINFOCONSTS
  const [step, changeStep] = useState(
    getStateValue(state, 'step', INITIAL_STEP)
  )

  const [estimatePrice, {called, error, data}] = useMutation(ESTIMATE_PRICE)
  const [input, setInput] = useState()
  const [stepStates, changeStepStates] = useState({
    listing: {
      types: [STEPINFOCONSTS.INITIAL_TYPE],
      mapPlaceholder: 'Selecione o endereço sugerido para carregar o mapa',
      mapIcon: '/img/icons/map-icon.svg',
      address: getStateValue(state, 'address', null),
      addressData: getStateValue(state, 'addressData', null),
      streetNumber: getStateValue(
        state,
        'streetNumber',
        state && state.streetNumberNotFound ? undefined : null
      ),
      streetNumberNotFound: getStateValue(state, 'streetNumberNotFound', false),
      postalCode: getStateValue(
        state,
        'postalCode',
        state && state.postalCodeNotFound ? undefined : null
      ),
      postalCodeNotFound: getStateValue(state, 'postalCodeNotFound', false),
      complement: null,
      price: null
    },
    info: {
      rooms: undefined,
      suites: undefined,
      bathrooms: undefined,
      area: undefined,
      maintenanceFee: undefined,
      garageSpots: undefined
    }
  })
  const [result, changeResult] = useState({
    error: true,
    icon: '/img/icons/exclamation-mark.svg',
    title: 'Ocorreu um erro',
    text: 'Tente enviar os dados novamente',
    button: 'Tentar novamente',
    buttonOnClick: () => changeStep(INITIAL_STEP)
  })

  const steps = {
    intro: {
      label: 'Avaliar Imóvel',
      component: Intro,
      stepBack: null,
      stepFwd: 'listing',
      stepProps: {
        onClick: () => changeStep('listing'),
        loggerAction: 'seller-evaluation-cta'
      }
    },
    listing: {
      label: 'Endereço',
      component: Listing,
      stepBack: 'intro',
      stepFwd: 'info',
      stepProps: {
        state: stepStates.listing,
        onChange: (value) => {
          changeStepStates({
            ...stepStates,
            listing: value
          })
        },
        loggerAction: {
          listTypes: 'seller-evaluation-step-listing-types',
          addressFocus: 'seller-evaluation-step-listing-address-focus',
          addressData: 'seller-evaluation-step-listing-address-data',
          listingComplement: 'seller-evaluation-step-listing-complement',
          streetNumber: 'seller-evaluation-step-listing-streetNumber',
          streetNumberNotFound:
            'seller-evaluation-step-listing-streetnumberotfounded',
          postalCode: 'seller-evaluation-step-listing-postalCode',
          postalCodeNotFound:
            'seller-evaluation-step-listing-postalCodeNotFounded'
        },
        onSubmit: onSubmitSteps
      }
    },
    info: {
      label: 'Informações do Imóvel',
      component: Info,
      stepBack: 'listing',
      stepFwd: 'send',
      stepProps: {
        state: stepStates.info,
        onChange: (value) => {
          changeStepStates({
            ...stepStates,
            info: value
          })
        },
        loggerAction: {
          rooms: 'seller-evaluation-step-information-rooms',
          suites: 'seller-evaluation-step-information-suites',
          bath: 'seller-evaluation-step-information-bath',
          area: 'seller-evaluation-step-information-area',
          condo: 'seller-evaluation-step-information-condo',
          garageSpots: 'seller-evaluation-step-information-garage'
        }
      }
    },
    send: {
      label: 'Carregando',
      stepFwd: 'success',
      stepProps: {
        sentences
      }
    },
    success: {
      label: 'Avaliação',
      stepFwd: 'intro',
      ...result
    }
  }

  const onSubmit = () => {
    const addressData = getAddressInput({
      addressData: stepStates.listing.addressData
    })
    const input = {
      address: {
        ...addressData,
        streetNumber: stepStates.listing.streetNumber,
        postalCode: stepStates.listing.postalCode
      },
      area: parseInt(stepStates.info.area),
      bathrooms: parseInt(stepStates.info.bathrooms),
      garageSpots:
        stepStates.info.garageSpots === 'Não'
          ? 0
          : parseInt(stepStates.info.garageSpots),
      rooms: parseInt(stepStates.info.rooms),
      suites: parseInt(stepStates.info.suites),
      maintenanceFee: stepStates.info.maintenanceFee,
      complement: stepStates.listing.complement,
      type: stepStates.listing.types[0],
      isCovered: true
    }
    setInput(input)
  }

  const history = useHistory()

  const onSubmitSteps = () => {
    if (!isFwdButtonDisabled()) {
      step === 'info' ? changeStep('send') : changeStep(steps[step].stepFwd)
    }
  }

  useEffect(() => {
    if (called && !error && !data) {
      logger.action('seller-evaluation-send', {input})
    } else if (called && data) {
      if (data.requestPriceSuggestion.suggestedPrice) {
        changeResult({
          success: true,
          minPrice: data.requestPriceSuggestion.listingPriceErrorQ90Min,
          estimatedPrice: data.requestPriceSuggestion.suggestedPrice,
          maxPrice: data.requestPriceSuggestion.listingPriceErrorQ90Max,
          listing: {
            address: stepStates.listing.address,
            types: stepStates.listing.types,
            streetNumber: stepStates.listing.streetNumber,
            streetNumberNotFound: false,
            postalCode: stepStates.listing.postalCode,
            postalCodeNotFound: false,
            addressData: stepStates.listing.addressData,
            complement: input.complement
          },
          info: {
            area: stepStates.info.area
          }
        })
        logger.action('seller-evaluation-step-send-success', {
          input
        })
        logger.action('seller-evaluation-step-sucess')
        changeStep('success')
      } else {
        logger.action('seller-evaluation-send-error', {
          value: data.requestPriceSuggestion.suggestedPrice || 0
        })
        changeStep('error')
      }
    } else if (error) {
      changeStep('error')
      logger.action('seller-evaluation-send-error', {
        value: 'error'
      })
    }
  }, [called, error, data])

  useEffect(() => {
    if (input) {
      estimatePrice({
        variables: {...input}
      })
    }
  }, [input])

  useEffect(() => {
    if (step === 'send') {
      logger.action('seller-evaluation-forward', {step: 'info'})
      onSubmit()
    } else if (step === 'success') {
      history.replace({...history.location, hash: 'sucesso'})
    } else if (step === 'error') {
      history.replace({...history.location, hash: 'erro'})
      logger.action('seller-evaluation-step-error', {step})
      changeResult({
        error: true,
        icon: '/img/icons/exclamation-mark.svg',
        title: 'Ocorreu um erro',
        text: 'Tente enviar os dados novamente',
        buttons: [
          {
            active: true,
            label: 'Tentar novamente',
            onClick: () => changeStep('listing')
          }
        ]
      })
    } else if (step === 'listing') {
      history.replace({...history.location, hash: 'endereco'})
      logger.action('seller-evaluation-step-listing')
    } else if (step === 'info') {
      history.replace({...history.location, hash: 'informacoes'})
      logger.action('seller-evaluation-forward', {step: 'address'})
      logger.action('seller-evaluation-step-information')
    } else if (step === 'intro') {
      history.replace({...history.location, hash: ''})
      logger.action('seller-evaluation-intro')
    }
  }, [step])

  return (
    <Shell noFooter>
      <HeadHelmet
        title="EmCasa - Avaliador de imóveis"
        description="A EmCasa te ajuda a encontrar Apartamentos à Venda com tecnologia e um time de especialistas, tornando a compra de um imóvel mais transparente, ágil e segura."
        url="https://emcasa.com/avaliar"
        image={`${process.env.CLOUDINARY_IMAGE_URL}/share/share-6`}
      />

      <StepByStep
        steps={steps}
        step={step}
        result={result}
        renderCompleted={Evaluation}
        navigateToStep={changeStep}
        backButtonLabel="Voltar"
        fwdButtonLabel={step === 'info' ? 'Avaliar' : 'Avançar'}
        isBackButtonDisabled={isBackButtonDisabled(steps, step, stepStates)}
        isFwdButtonDisabled={isFwdButtonDisabled(steps, step, stepStates)}
        onBackButtonClick={() =>
          logger.action('seller-evaluation-step-button-back', {step})
        }
        onFwdButtonClick={() => {
          logger.action('seller-evaluation-button-next', {step})
        }}
        onHandleLastFwdClick={() => changeStep('send')}
      />
    </Shell>
  )
}

export default Evaluator
